import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

// external modules
// import VueMapboxTs from "vue-mapbox-ts"

import { createI18n } from 'vue-i18n'
import VueSocketIOExt from 'vue-socket.io-extended'
// @ts-ignore
import { io } from 'socket.io-client'

// import vClickOutside from 'click-outside-vue3'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/de'
dayjs.extend(relativeTime)
dayjs.locale(store.state.locale || 'en')

import localforage from 'localforage'

// own modules
// import VModal from './components/____VModal.vue'
// // import VDate from './components/VDate.vue'
// import VDateInput from './components/VDateInput.vue'
import VPopover from './components/VPopover.vue'
// import VColorChooser from './components/VColorChooser.vue'

// import vDebounce from './features/projects/DebouceWrapper.vue'

// import BBFileList from './components/BBFileList.bkp.vue'
// import BBFilePreview from './components/BBFilePreview.bkp.vue'
// import BBFileUpload from './components/BBFileUpload.bkp.vue'

import ModulesList from './features/moduls/ModulesList.vue'

// import AssignHub from './features/hubs/____AssignHub.vue'
// import Dashboard from './components/Dashboard.vue'

import mixin from './libs/mixins'
// import customLodash from './libs/customLodash'

// external styles
import 'vue-select/dist/vue-select.css'
// import './styles/tailwind.css'
// import './styles/layout.css'
// import './styles/style.css'

import './styles/style.css'
import './styles/tailwind.css'
import './styles/layout.css'
import './styles/components.css'
import './styles/mapbox.css'
import './styles/files.css'
import './styles/rev-menu.css'
import './styles/pikaday.css'

// import './assets/styles/tawi.css'
// import './assets/styles/layout.css'
// import './assets/styles/style.css'

// import './assets/styles/tailwind.scss'
// import './assets/icons/rendered/icons.css'
// import './assets/styles/style.scss'

// import './assets/styles/style.css'
// import './assets/styles/tawi.css'
// import './assets/styles/custom.scss'
// import './assets/styles/colors.scss'
// import './assets/styles/mapbox.scss'
// import './assets/styles/multiselect.scss'
// import './assets/styles/multiselect.css'

// import './assets/styles/multiselect.scss'
// import "@vueform/multiselect/themes/dafault.css"
// import '@vueform/multiselect/themes/tailwind.css'

// const wsOptions = require("./libs/websocketsConfig").default
// const vueSocket = new VueSocketIOExt("http://127.0.0.1:9877")
// const env = require("./env").default

import env from './env'
// const translations = require("./translations").default
import { translations } from './translations'

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const socket = io(env.wsUrl, {
	path: env.wsPath,
	autoConnect: false,
	withCredentials: true,
	extraHeaders: { accesstoken: '-' }, // will be set before connect
})

const i18n = createI18n({
	messages: translations,
  legacy: false,
	// locale: 'de', // set locale
	locale: store.state.locale, // set locale
	fallbackLocale: 'en', // set fallback locale
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

console.log(pinia)

const app = createApp(App)
	.use(store)
	.use(router)
	.use(pinia)
	// .use(VueMapboxTs)
	// .use(VueMeta, metaInfo)
	// .use(vClickOutside)
	.use(VueSocketIOExt, socket, { store })
	.use(i18n)
	.use(FloatingVue)
	// .directive('debounce', vDebounce)

	// .component('v-modal', VModal)
	// .component('v-switch', VSwitch)
	// .component('v-date', VDate)
	// .component('v-date-input', VDateInput)
	.component('v-popover', VPopover)
	// .component('v-multiselect', VueMultiselect)
	// .component('v-dragdrop', VDragDrop)
	// .component('v-colorchooser', VColorChooser)
	// .component('Multiselect', Multiselect)
	.component('ModulesList', ModulesList)

	// .component("Dashboard", Dashboard)

	.mixin(mixin)

app.config.globalProperties.$dayjs = dayjs
// app.config.globalProperties.$env = env
// app.config.globalProperties.keyBy = customLodash.keyBy
// app.config.globalProperties.sortBy = customLodash.sortBy

// constants
// app.config.globalProperties.THIS_YEAR = new Date().getFullYear()
const THIS_YEAR = new Date().getFullYear()
const THIS_YEAR_UNIXTS = dayjs(THIS_YEAR + '', 'YYYY').unix()
app.config.globalProperties.THIS_YEAR_UNIXTS = THIS_YEAR_UNIXTS

const now = parseInt(Date.now() / 1000 + '')
const THREE_HOURS_BEFORE = now - 60 * 60 * 3
app.config.globalProperties.THREE_HOURS_BEFORE = THREE_HOURS_BEFORE

const graphStorage = localforage.createInstance({ name: 'graphs' })

app.config.globalProperties.$graphStorage = graphStorage
app.mount('#app')

// helper
try {
	setTimeout(async () => {
		// const graphStorage = localforage.createInstance({ name: "graphs" })
		const allAvailableStoreKeys = await graphStorage.keys()
		for await (const el of allAvailableStoreKeys) {
			const a: string = (await graphStorage.getItem(el)) || '{}'
			const r: any = JSON.parse(a)
			// console.log(el)
			if (minutesSince(r.created || 0) > 14) graphStorage.removeItem(el)
		}
	}, 5000)
	const minutesSince = (num: number) => (Date.now() - num) / 1000 / 60
} catch (error: any) {
	console.log(error)
}
;(window as any).dayjs = dayjs
